module.exports = __webpack_public_path__ + "img/8a0636c.png";